export default __webpack_public_path__ + "images/cabin_bag_small.d87ddec.svg";